import styled from 'styled-components';
import PropTypes from 'prop-types';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { Spacings, Fonts } from '../../../../styleConstants';

const Card = styled.div`
  display: grid;
  grid-template: max-content max-content / 1fr;
  grid-row-gap: ${Spacings.SPACING_6B};
  box-shadow: ${boxShadowGenerator({
    xOffset: -`${Spacings.SPACING_4B}`,
    yOffset: Spacings.SPACING_4B,
    blur: Spacings.SPACING_6B,
    color: 'rgba(220, 239, 253, 0.2)'
  })};
  border-radius: ${Spacings.SPACING_4B};
  padding: ${Spacings.SPACING_6B};
  color: ${({ $textColor }) => $textColor};
  background-color: ${({ $bgColor }) => $bgColor};
  margin-top: ${Spacings.SPACING_5B};
`;

const CardLabel = styled.div`
  font-weight: ${Fonts.SEMIBOLD};
  font-size: ${Fonts.H3};
  line-height: 30px;
`;

const CardInfo = styled.div`
  font-weight: ${Fonts.REGULAR};
  font-size: ${Fonts.H5};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
`;

const EventCardMobile = ({ title, textColor, bgColor, description }) => {
  return (
    <Card $bgColor={bgColor} $textColor={textColor}>
      <CardLabel>{title}</CardLabel>
      <CardInfo>{description}</CardInfo>
    </Card>
  );
};

EventCardMobile.propTypes = {
  title: PropTypes.string.isRequired,
  textColor: PropTypes.string.isRequired,
  bgColor: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
};

export default EventCardMobile;
